<div class="closed-zone" id="swipeZone">
  <div class="closed-zone__line"></div>
</div>
<ion-content class="container">
  <span class="container__title">
    Order from
    <ion-button (click)="closeModal()" class="container__close-btn" fill="clear" color="dark">
    <svg slot="icon-only" class="container__close-btn-icon" aria-label="Container">
      <use xlink:href="./assets/images/icons-sprite.svg#icon-close"></use>
    </svg>
  </ion-button>
  </span>
  <ion-list lines="none" class="container__list">
      <div class="container__list-item" no-lines *ngFor="let location of locationList; index as locationIndex"
                [class.container__list-item--active]="isChosenLocation(locationIndex)"
                [ngStyle]="{'background-image': formatToStyleImageUrl(location)}"
                (click)="chooseLocation(locationIndex)"
      >
        <span class="container__list-item-label" [ngStyle]="{'color': !location.isMobileEnabled ? 'var(--color-gray-light-2)' : '#F5F6F8'}">{{location.name}}</span>
        <a *ngIf="location?.contactPhoneNumber" class="container__list-item-phone" href="tel:{{formatPhoneNumber(location?.contactPhoneNumber, 'international')}}" (click)="$event.stopPropagation()">
          <img class="container__list-item-img" src="./assets/icon/phone_in_circle_icon.svg" alt="logo">
        </a>
      </div>
  </ion-list>
</ion-content>